<!--
 * @Author: LZT
 * @Date: 2024-12-12 13:27:12
 * @LastEditors: ITDLCL
 * @Description:
 * @FilePath: \qs\src\Layout\index.vue
-->
<template>
  <HeaderNav
    v-if="meta.showHead"
    :left-arrow="Boolean(meta.showLeft)"
    :right-arrow="Boolean(meta.showRight)"
    :titel-text="meta.title"
    :route-meta="meta"
    :source-type="sourceType"
    :nav-bg="meta.navBg"
    :nav-text-color="meta.navTextColor"
    :nav-style="meta.navStyle"
    :rightIcon="meta.rightIcon"
    :slefBack="meta.slefBack"
  />
  <div
    class="gn_app-main"
    :class="{
      'main-head': meta.showHead,
      'main-bottom': meta.showFooter
    }"
    style=""
  >
    <div
      class="body-wrap"
      :style="{ paddingTop: adhibitionStore.environment.isApp ? barHeight + 'px' : '0px' }"
    >
      <router-view v-slot="{ Component }">
        <keep-alive>
          <component v-if="isKeepAlive" :key="route.fullPath" :is="Component" />
        </keep-alive>
        <component v-if="!isKeepAlive" :key="route.fullPath" :is="Component" />
      </router-view>
    </div>
  </div>
  <FooterNav v-if="meta.showFooter" />
</template>

<script setup>
import HeaderNav from "./components/HeaderNav.vue";
import FooterNav from "./components/FooterNav.vue";
import { useAdhibitionStore } from "@/stores/adhibition";
import useUsersStore from "@/stores/user";
const userStore = useUsersStore();
const adhibitionStore = useAdhibitionStore();

const route = useRoute();
const barHeight = computed(() => userStore.barHeight);
const routeData = toRaw(route);
const sourceType = ref(""); // APP的来源
const meta = ref({});
const isKeepAlive = computed(() => route.meta.keepAlive);

function setPageProperty() {
  if (routeData.query["appName"]) {
    sourceType.value = routeData.query["appName"];
  }
}
onActivated(() => {
  setPageProperty();
  // 适配Flutter App 顶部导航栏是否隐藏
  const isFlutterHeaderNav = route.query.isFlutterHeaderNav;
  if (isFlutterHeaderNav == 'false' || isFlutterHeaderNav === false) {
    meta.value = { ...route.meta, showHead: false };
    return;
  };
  meta.value = { ...route.meta };
});

onMounted(() => {
  setPageProperty();
  // 适配Flutter App 顶部导航栏是否隐藏
  const isFlutterHeaderNav = route.query.isFlutterHeaderNav;
  if (isFlutterHeaderNav == 'false' || isFlutterHeaderNav === false) {
    meta.value = { ...route.meta, showHead: false };
    return;
  };
  meta.value = { ...route.meta };
});
</script>
<style lang="scss" scoped>
.gn_app-main {
  position: relative;
  width: 100%;
  height: 100%;
  // min-height: 100%;
  // padding-bottom: constant(safe-area-inset-bottom);
  // padding-bottom: env(safe-area-inset-bottom);
  .body-wrap {
    width: 100%;
    height: 100%;
  }
}
.main-head {
  padding-top: 46px;
}
</style>
